<template>
	<div>
		<!-- 侧边栏 -->
		<div class="sidebar">
			<div class="sidebar-top">
				<div class="user d-flex justify-content-center align-items-center" @mouseover="selectStyle(0)" @mouseout="outStyle()"
				 :class="{active: 0 ==iShow}" v-if="!login">
					<div class="sidebar-img">
						<img class="img-default" src="../../assets/images/user.png" alt />
					</div>
					<div class="user-item d-flex align-items-center" :class="{item_active:0==iShow}" @click="goTo()">
						<div class="user-item-l">
							<div class="user-item-img">
								<img class="img-default" :src="user.avatar_url" alt="">
							</div>
						</div>
						<div class="user-item-r">
							<div class="user-name">
								<span>{{user.nickname}}</span>
								<span></span>
								<span @click.stop="signout()">退出</span>
							</div>
							<div class="user-item-hui">普通会员</div>
						</div>
					</div>
				</div>
				<div class="coupon d-flex justify-content-center align-items-center" @mouseover="selectStyle(1)" @mouseout="outStyle()"
				 :class="{active: 1==iShow}" v-if="false">
					<div class="sidebar-img">
						<img class="img-default" src="../../assets/images/coupon_w.png" alt />
					</div>
					<div class="coupon-item" :class="{item_active: 1==iShow}"></div>
				</div>
				<div class="cat d-flex align-items-center flex-direction-column" @mouseover="selectStyle(2)" @mouseout="outStyle()"
				 :class="{active: 2==iShow}">
					<div class="sidebar-img">
						<img class="img-default" src="../../assets/images/sidebar_cat.png" alt />
					</div>
					<div class="cat-name">购 物 车</div>
					<div class="cat-num d-flex justify-content-center align-items-center" v-text="cart_num"></div>
					<div class="cat-item" :class="{item_active: 2==iShow}"></div>
				</div>
			</div>
			<div class="sidebar-bottom">
				<div class="qr d-flex justify-content-center align-items-center qred" @mouseover="selectStyle(3)" @mouseout="outStyle()"
				 :class="{active: 3 ==iShow}" v-if="false">
					<div class="sidebar-img">
						<img class="img-default" src="../../assets/images/qr.png" alt />
					</div>
					<div class="qr-hidden d-flex justify-content-between" :class="{item_active: 3==iShow}">
						<div class="qr-item d-flex align-items-center flex-direction-column justify-content-between">
							<div class="qr-box">
								<div class="qr-img"></div>
							</div>
							<div class="qr-name">APP下载</div>
						</div>
						<div class="qr-item d-flex align-items-center flex-direction-column justify-content-between">
							<div class="qr-box">
								<div class="qr-img"></div>
							</div>
							<div class="qr-name">进入商城小程序</div>
						</div>
					</div>
				</div>
				<div class="qr d-flex justify-content-center align-items-center">
					<div class="sidebar-img" @click="logup()">
						<img class="img-default" src="../../assets/images/top_w.png" alt />
					</div>
				</div>
			</div>
			<!-- 优惠券 -->
			<div class="sidebar-coupon" @mouseover="selectStyle(1)" @mouseout="outStyle()" :class="{item_active:1==iShow}">
				<div class="coupon-tab d-flex">
					<div class="coupon-tab-item" @click="couponTab(0)" :class="{coupon_active: 0 == couponIndex}">可领取优惠券</div>
					<div class="coupon-tab-item" @click="couponTab(1)" :class="{coupon_active: 1 == couponIndex}">已领取优惠券</div>
				</div>
				<div class="coupon-item d-flex flex-direction-column justify-content-between" v-for="(item,index) in couponList"
				 :key="index" v-show="couponList!=''">
					<div class="coupon-top d-flex align-items-center justify-content-between">
						<div class="coupon-pic">
							<div class="num">¥{{item.sub_price}}</div>
							<div class="meet">满{{item.min_price}}使用</div>
						</div>
						<div class="coupon-btn d-flex align-items-center justify-content-center" v-if="item.is_receive ==0" @click="couponReceive(item.id)">立即领取</div>
						<div class="coupon-btn d-flex align-items-center justify-content-center" v-if="item.is_receive ==1">已领取</div>
					</div>
					<div class="coupon-time" v-if="item.expire_type==2">有效期：{{item.begintime}}-{{item.endtime}}</div>
					<div class="coupon-time" v-if="item.expire_type==1">有效期：领取{{item.expire_day}}天内有效</div>
				</div>
				<div class="couponNull d-flex justify-content-center" v-show="couponList==''">
					暂无可用优惠券
				</div>
			</div>
			<!-- 购物车 -->
			<div class="sidebar-cat" @mouseover="selectStyle(2)" @mouseout="outStyle()" ref="element" :class="{item_active: 2==iShow}">
				<div style="width: 100%;height: 100%;position: absolute;top: 0;" v-if="ttshop_catlist.length || ttshop_mchlist.length">
					<div class="top d-flex justify-content-between align-items-center" ref="top">
						<div class="top-select d-flex align-items-center" @click="checkAll()">
							<div class="top-img">
								<img class="img-default" v-if="check_all" src="../../assets/images/select_checked.png" alt />
								<img class="img-default" v-else src="../../assets/images/select_unchecked.png" alt />
							</div>已选{{num_all}}件
						</div>
						<div class="top-all" @click="gocat()">查看全部</div>
					</div>
					<div class="store-box" :style="{height: domheight + 'px',overflowY: overtype  ? 'scroll': 'hidden'}">
						<div ref="boxheight">
							<!-- 店铺 -->
							<template v-if="ttshop_mchlist && ttshop_mchlist.length">
								<template v-for="(item,index) in ttshop_mchlist">
									<template v-if="item.list && item.list.length">
										<div class="shore d-flex align-items-center justify-content-between">
											<div class="shore-select d-flex align-items-center">
												<div class="shore-img" @click="checkGroup(1,index)">
													<img class="img-default" v-if="item.checked" src="../../assets/images/select_checked.png" alt />
													<img class="img-default" v-else src="../../assets/images/select_unchecked.png" alt />
												</div>
												<span>{{item.name}}</span>
											</div>
											<!-- <div class="shore-pic">¥{{price_all}}</div> -->
										</div>
										<!-- 商品 -->
										<div class="shop-box">
											<template v-for="(itemChild,indexChild) in item.list">
												<div class="shoped d-flex align-items-center">
													<div class="item checkWrap not-num" v-if="itemChild.status != 1 || itemChild.goods_is_del == 1">
														<div>失效</div>
													</div>
													<div class="item checkWrap not-num" v-else-if="itemChild.disabled">
														<div>无货</div>
													</div>
													<div class="shop-select" @click="checkItem(1,indexChild,index)" v-else>
														<img class="img-default" v-if="itemChild.checked" src="../../assets/images/select_checked.png" alt />
														<img class="img-default" v-else src="../../assets/images/select_unchecked.png" alt />
													</div>
													<div class="shop-img">
														<img class="img-default" :src="itemChild.goods_pic" alt />
													</div>
													<div class="shop-r">
														<div class="shop-name" v-text="itemChild.goods_name"></div>
														<div class="shop-name">
															<span v-for="(itemAttr,indexAttr) in itemChild.attr_list" v-text="itemAttr.attr_name"></span>
														</div>
														<div class="shop-r-b d-flex align-items-center justify-content-between">
															<el-input-number v-model="itemChild.num" @change="handleChange(itemChild.num, index)" :min="1" :max="itemChild.max_num >= itemChild.num ? itemChild.max_num : itemChild.num"
															 label="描述文字"></el-input-number>
															<div class="shop-pic">¥{{(itemChild.num * itemChild.unitPrice).toFixed(2)}}</div>
														</div>
													</div>
													<div class="deletecat" @click="deleteItem(1,indexChild,index)">
														<img class="img-default" src="../../assets/images/delect.svg" alt="">
													</div>
												</div>
											</template>
										</div>
									</template>
								</template>
							</template>
							<!-- 自营 -->
							<div class="ziying">
								<div class="shore d-flex align-items-center justify-content-between">
									<div class="shore-select d-flex align-items-center">
										<div class="shore-img" @click="checkGroup(2)">
											<img class="img-default" v-if="check_list" src="../../assets/images/select_checked.png" alt />
											<img class="img-default" v-else src="../../assets/images/select_unchecked.png" alt />
										</div>
										<span>平台自营</span>
									</div>
									<!-- <div class="shore-pic">¥{{price_all}}</div> -->
								</div>
								<div class="shop-box">
									<template  v-for="(item,index) in ttshop_catlist">
										<!-- 普通商品 -->
										<div class="shoped d-flex align-items-center" v-if="item.parts_id == 0">
											<div class="item checkWrap not-num" v-if="item.status != 1 || item.goods_is_del == 1">
												<div>失效</div>
											</div>
											<div class="item checkWrap not-num" v-else-if="item.disabled">
												<div>无货</div>
											</div>
											<div class="shop-select" @click="checkItem(2,index)" v-else>
												<img class="img-default" v-if="item.checked" src="../../assets/images/select_checked.png" alt />
												<img class="img-default" v-else src="../../assets/images/select_unchecked.png" alt />
											</div>
											<div class="shop-img">
												<img class="img-default" :src="item.goods_pic" alt />
											</div>
											<div class="shop-r">
												<div class="shop-name">{{item.goods_name}}</div>
												<div class="shop-name">
													<span v-for="(items,index) in item.attr_list">{{items.attr_name}}</span>
												</div>
												<div class="shop-r-b d-flex align-items-center justify-content-between">
													<el-input-number v-model="item.num" @change="handleChange(item.num, index)" :min="1" :max="item.max_num >= item.num ? item.max_num : item.num"
													 label="描述文字"></el-input-number>
													<div class="shop-pic">¥{{(item.num * item.unitPrice).toFixed(2)}}</div>
												</div>
											</div>
											<div class="deletecat" @click="deleteItem(2,index)">
												<img class="img-default" src="../../assets/images/delect.svg" alt="">
											</div>
										</div>
										<!-- 套餐 -->
										<div class="set-meal" v-else>
											<div class="set-meal-title d-flex align-items-center">
												<div class="item checkWrap not-num" v-if="item.status != 1 || item.goods_is_del == 1">
													<div>失效</div>
												</div>
												<div class="item checkWrap not-num" v-else-if="item.disabled">
													<div>无货</div>
												</div>
												<div class="shop-select" @click="checkItem(2,index)" v-else>
													<img class="img-default" v-if="item.checked" src="../../assets/images/select_checked.png" alt />
													<img class="img-default" v-else src="../../assets/images/select_unchecked.png" alt />
												</div>
												<span class="set-meal-txt">套餐</span>
												<p class="set-meal-name show-one-lines flex_1" v-text="item.title"></p>
												<div class="deletecat" @click="deleteItem(3,index)">
													<img class="img-default" src="../../assets/images/delect.svg" alt="">
												</div>
											</div>
											<div class="set-meal-goods">
												<div class="shoped d-flex align-items-center" v-for="(itemChild,indexChild) in item.list" :key="indexChild">
													<div class="shop-select not"></div>
													<div class="shop-img">
														<img class="img-default" :src="itemChild.goods_pic" alt />
													</div>
													<div class="shop-r">
														<div class="shop-name" v-text="itemChild.goods_name"></div>
														<div class="shop-name">
															<span v-for="(itemAttr,indexAttr) in itemChild.attr_list" :key="indexAttr" v-text="itemAttr.attr_name"></span>
														</div>
													</div>
												</div>
											</div>
											<div class="set-meal-info d-flex justify-content-end">
												<div class="set-meal-info-cont shop-r-b d-flex align-items-center justify-content-between">
													<el-input-number v-model="item.num" @change="handleChange(item.num, index)" :min="1" :max="item.max_num >= item.num ? item.max_num : item.num" label="描述文字"></el-input-number>
													<div class="shop-pic">¥{{(item.num * item.price).toFixed(2)}}</div>
												</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
					<div class="cat-bottom cat-bottoms d-flex justify-content-between align-items-center" ref="bottom">
						<div class="bottom-l">
							<div>已选 {{num_all}}件商品</div>
							<div>总价：¥{{price_all}}</div>
						</div>
						<div class="bottom-btn d-flex align-items-center justify-content-center" @click="submitPreview()">去购物车结算</div>
					</div>

				</div>
				<!-- 购物车暂无商品时显示 -->
				<template v-else>
					<div class="zntj" v-if='datatype'>
						<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
						<p>购物车空空如也</p>
					</div>
				</template>
				<!-- 未登录显示 -->
				<div class="noloding" v-if="login">
					<img class="img-default" src="../../assets/images/wloding.png" alt="">
					<p>您还未登录 <span @click="goloding()">请登录</span></p>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import "./sidebar.css";
	export default {
		name: "Sidebar",
		props: ["goodsId"],
		data() {
			return {
				iShow: -1,
				couponIndex: 0,
				num: 1,
				domheight: 0,
				overtype: false,
				datatype: false,
				check_list: false,
				check_all: false,
				ttshop_catlist: "", //商品列表
				ttshop_mchlist: "", //店铺商品
				price_all: "0.00", //总金额
				num_all: 0, //商品总数
				row_count: 0, //商品件数
				login: false,
				getList: [],
				unList: [],
				couponList: [],
				cart_num: 0,
			};
		},
		created() {
			let that = this;
			that.user = that.$store.state.user;
			if (that.$store.state.user) {
				if (that.user.token == "") {
					that.login = true;
				} else {
					that.login = false;
					this.shopcatapi();
					this.cartNum();
				}
			} else {
				that.login = true;
			}
		},
		watch: {
			goodsId: function(newId, ordId) {
				if (newId != ordId) {
					this.getCoupon(newId);
				}
			},
		},
		mounted() {},
		updated() {
			if(this.$refs.boxheight){
				let height = this.$refs.element.offsetHeight;
				let top = this.$refs.top.offsetHeight;
				let bottom = this.$refs.bottom.offsetHeight;
				let boxheight = this.$refs.boxheight.offsetHeight;
				this.domheight = height;
				if (height - top - bottom < boxheight) {
					this.overtype = true;
				}
			}
		},
		methods: {
			// 获取购物车数量
			cartNum(){
				this.$api.cartnum().then((res) => {
					this.cart_num = res.data;
				})
				.catch((err) => {
					console.log(err);
				});
			},
			// 优惠券切换
			couponTab(index) {
				let _this = this;
				if (_this.couponIndex != index) {
					_this.couponIndex = index;
					if (index == 0) {
						_this.couponList = _this.getList;
					} else {
						_this.couponList = _this.unList;
					}
				}
			},
			// 优惠券列表
			getCoupon(id) {
				let data = {
					goods_id: id
				};
				this.$api
					.couponList(data)
					.then((res) => {
						let couponArr = res.data.list;
						let getList = [],
							unList = [];
						for (let i in couponArr) {
							if (couponArr[i].is_receive == 0) {
								getList.push(couponArr[i]);
							} else {
								unList.push(couponArr[i]);
							}
						}
						if (this.couponIndex == 0) {
							this.couponList = getList;
						} else {
							this.couponList = unList;
						}
						this.getList = getList;
						this.unList = unList;
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 优惠券领取
			couponReceive(id) {
				this.$api
					.ccouponReceive({
						id: id
					})
					.then((res) => {
						// this.ttshop_goodsleft = res.data.list;
						this.$message({
							showClose: true,
							message: "领取成功",
							type: "warning",
							offset: 200,
							duration: 1000,
						});
						this.getCoupon()
					})
					.catch((err) => {
						this.$message({
							showClose: true,
							message: "领取失败",
							type: "warning",
							offset: 200,
							duration: 1000,
						});
						this.getCoupon()
					});
			},
			// 去登陆
			goloding() {
				this.$router.push({
					name: "signin",
					query: {
						redirect: this.$router.currentRoute.fullPath,
					},
				});
			},
			//退出登录
			signout() {
				window.localStorage.removeItem('userInfo');
				this.$store.commit("userInfo", '');
				this.user = "";
				this.login = true;
				this.$router.push("/");
				window.location.reload();
			},
			goTo() {
				this.$router.push("/ttshop_user");
			},
			// 购物车数据
			shopcatapi(callback) {
				this.datatype = false;
				this.$api.shopcat().then(res => {
					let list = res.data.list;
					if (list) {
						for (let i in list) {
							if (list[i].parts_id != 0) {
								let status = 1; //1上架 其它则为下架商品
								let goods_is_del = 0; //0 正常 1已删除
								for (let j in list[i].list) {
									if (list[i].list[j].status != 1) {
										status = 0;
									}
									if (list[i].list[j].goods_is_del != 0) {
										goods_is_del = 1;
									}
								}
								list[i].status = status;
								list[i].goods_is_del = goods_is_del;
							}
						}
					}
					this.ttshop_catlist = list;
					this.ttshop_mchlist = res.data.mch_list;
					this.datatype = true;
					if (callback) {
						callback();
					}
				}).catch(err => {
					this.common.message(this, err)
					console.log(err);
				});
			},
			// 加减
			handleChange(value, index) {
				let that = this;
				let list = that.ttshop_catlist;
				let num = list[index].num;
				if (list[index].max_num >= num) {
					list[index].disabled = false;
				}
				that.ttshop_num = value;
				that.calculatePrice();
				that.throttle();
			},
			// 节流
			throttle() {
				let vaild = true;
				if (!vaild) {
					return false;
				}
				vaild = false;
				setTimeout(() => {
					this.modifycart();
					vaild = true;
				}, 800);
			},
			//购物车修改
			modifycart() {
				let that = this;
				let list = that.ttshop_catlist;
				let new_list = [];
				if (list) {
					for (let i in list) {
						if (list[i].parts_id != 0) {
							for (let j in list[i].list) {
								new_list.push(list[i].list[j]);
							}
						} else {
							new_list.push(list[i]);
						}
					}
				}
				let data = {
					list: JSON.stringify(new_list)
				};
				this.$api.modifycart(data).then(res => {
					// console.log(res)
				}).catch(err => {
					console.log(err);
				});
			},
			// 全选
			checkAll() {
				let that = this;
				let list = that.ttshop_catlist;
				let mch_list = that.ttshop_mchlist;
				let check_all = !that.check_all;
				for (let i in list) {
					list[i].checked = check_all;
				}
				for (let i in mch_list) {
					mch_list[i].checked = check_all;
					for (let j in mch_list[i].list) {
						mch_list[i].list[j].checked = check_all;
					}
				}
				that.ttshop_catlist = list;
				that.ttshop_mchlist = mch_list;
				that.check_all = check_all;
				that.check_list = check_all;
				that.calculatePrice();
			},
			// 商品组选中
			checkGroup(types,index) {
				let that = this;
				let type = types;
				let list = that.ttshop_catlist;
				let mch_list = that.ttshop_mchlist;
				if (type == 1) { //mch_list
					let inx = index;
					mch_list[inx].checked = !mch_list[inx].checked;
					for (let i in mch_list[inx].list) {
						mch_list[inx].list[i].checked = mch_list[inx].checked;
					}
					that.ttshop_mchlist = mch_list
				} else if (type == 2) { //list
					for (let i in list) {
						list[i].checked = !that.check_list;
					}
					that.ttshop_catlist = list;
					that.check_list = !that.check_list;
				}
				let check_all = true;
				if (!that.check_list && list.length) {
					check_all = false;
				}
				for (let i in mch_list) {
					if (!mch_list[i].checked && mch_list[i].list.length) {
						check_all = false;
					}
				}
				that.check_all = check_all
				that.calculatePrice();
			},
			//单个商品选中
			checkItem(typeed, index,group_index) {
				let that = this;
				let type = typeed;
				let goods_inx = index;
				let goods_group_inx = group_index;
				let list = that.ttshop_catlist;
				let mch_list = that.ttshop_mchlist;
				if (type == 1) { //mch_list
					let group_type = true;
					mch_list[goods_group_inx].list[goods_inx].checked = !mch_list[goods_group_inx].list[goods_inx].checked;
					for (let i in mch_list[goods_group_inx].list) {
						if (!mch_list[goods_group_inx].list[i].checked && !mch_list[goods_group_inx].list[i].disabled && mch_list[
								goods_group_inx].list[i].status == 1 && mch_list[goods_group_inx].list[i].goods_is_del == 0) {
							group_type = false;
						}
					}
					mch_list[goods_group_inx].checked = group_type;
					that.ttshop_mchlist = mch_list
				} else if (type == 2) { //list
					this.$set(list[goods_inx], "checked", !list[goods_inx].checked)
					let group_type = true;
					for (let i in list) {
						if (!list[i].checked && !list[i].disabled && list[i].status == 1 && list[i].goods_is_del == 0) {
							group_type = false;
						}
					}
					that.ttshop_catlist = list;
					that.check_list = group_type
				}
				//
				let check_all = true;
				if (!that.check_list && list.length) {
					check_all = false;
				}
				for (let i in mch_list) {
					if (!mch_list[i].checked && mch_list[i].list.length) {
						check_all = false;
					}
				}
				that.check_all = check_all
				that.calculatePrice();
			},
			// 计算价格
			calculatePrice() {
				let that = this;
				let list = that.ttshop_catlist;
				let mch_list = that.ttshop_mchlist;
				let price = 0;
				let num = 0;
				for (let i in list) {
					if (list[i].checked && !list[i].disabled && list[i].status == 1 && list[i].goods_is_del == 0) {
						price += Number(list[i].num) * Number(list[i].unitPrice) || Number(list[i].num) * Number(list[i].price);
						num += Number(list[i].num);
					}
				}
				for (let i in mch_list) {
					for (let j in mch_list[i].list) {
						if (mch_list[i].list[j].checked && !mch_list[i].list[j].disabled && mch_list[i].list[j].status == 1 && mch_list[i]
							.list[j].goods_is_del == 0) {
							price += Number(mch_list[i].list[j].num) * Number(mch_list[i].list[j].unitPrice);
							num += Number(mch_list[i].list[j].num);
						}
					}
				}
				that.price_all = price.toFixed(2);
				that.num_all = num;
			},
			// 单个商品删除
			deleteItem(typer, index, group_index) {
				let that = this;
				let type = typer;
				let goods_inx = index;
				let goods_group_inx = group_index;
				let list = that.ttshop_catlist;
				let mch_list = that.ttshop_mchlist;
				let remove_cart_id = [];
				if (type == 1) { //mch_list商品
					remove_cart_id.push(mch_list[goods_group_inx].list[goods_inx].cart_id)
					mch_list[goods_group_inx].list.splice(goods_inx, 1);
					if(mch_list[goods_group_inx].list.length<=0){
						mch_list.splice(goods_group_inx, 1);
					}
					that.ttshop_mchlist = mch_list;
				} else if (type == 2) { //list商品
					remove_cart_id.push(list[goods_inx].cart_id)
					list.splice(goods_inx, 1);
					that.ttshop_catlist = list;
				} else if (type == 3) { //list优惠套餐
					for (let i in list[goods_inx].list) {
						remove_cart_id.push(list[goods_inx].list[i].cart_id);
					}
					list.splice(goods_inx, 1);
				}
				that.calculatePrice();
				that.deleteFun(remove_cart_id);
			},
			// 删除商品请求接口
			deleteFun(remove_cart_id, callback) {
				let data = {
					cart_id_list: JSON.stringify(remove_cart_id)
				};
				this.$api.delectshop(data).then(res => {
					if (res.code == 0) {
						this.$message({
							showClose: false,
							message: res.msg,
							center: true,
							type: 'success',
							offset: 200,
							duration: 1000
						});
						if (callback) {
							callback();
						}
					}
				}).catch(err => {
					console.log(err);
				});
			},
			// 进入购物车
			gocat() {
				this.$router.push("/cat");
			},
			// 结算
			submitPreview() {
				let that = this;
				let list = that.ttshop_catlist;
				let mch_list = that.ttshop_mchlist;
				let new_arr = []; //待提交数组
				let list_check = []; //自营选中商品
				// 自营选中商品
				for (let i in list) {
					if (list[i].checked && !list[i].disabled && list[i].status == 1 && list[i].goods_is_del == 0) {
						if (list[i].parts_id != 0) {
							for (let j in list[i].list) {
								list_check.push({
									cart_id: list[i].list[j].cart_id
								});
							}
						} else {
							list_check.push({
								cart_id: list[i].cart_id
							});
						}
					}
				}
				if (list_check.length > 0) {
					new_arr.push({
						mch_id: 0,
						goods_list: list_check
					});
				}
				// 店铺选中商品
				for (let i in mch_list) {
					let goods_list = [];
					for (let j in mch_list[i].list) {
						if (mch_list[i].list[j].checked && !mch_list[i].list[j].disabled && mch_list[i].list[j].status == 1 && mch_list[i]
							.list[j].goods_is_del == 0) {
							goods_list.push({
								cart_id: mch_list[i].list[j].cart_id
							});
						}
					}
					if (goods_list.length > 0) {
						new_arr.push({
							mch_id: mch_list[i].id,
							goods_list: goods_list
						})
					}
				}
				if (new_arr.length > 0) {
					let params = {
						mch_list: JSON.stringify(new_arr)
					}
					this.$store.commit("submitOrderRarams", params);
					this.$router.push({
						name: 'submitOrder'
					})
				} else {
					this.$message({
						showClose: true,
						message: '您还没有选择商品哦',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
				}
			},
			selectStyle(index) {
				let _this = this;
				_this.iShow = index;
			},
			outStyle() {
				this.iShow = -1;
			},

			// 返回顶部
			logup() {
				this.common.backTop(30);
			},
		},
	};
</script>

<style lang="scss" scoped>
	// 侧边栏
	.active {
		background-color: #ff4300 !important;
	}

	.item_active {
		visibility: visible !important;
		opacity: 1 !important;
	}

	.coupon_active {
		border-color: #ff0e25 !important;
		color: #ff0e25 !important;
	}

	.sidebar {
		width: 36px;
		height: 100%;
		background: #333333;
		position: fixed;
		top: 0;
		right: 0;
		z-index: 10;

		// position: relative;
		.sidebar-img {
			height: 20px;
			width: 20px;
		}

		.sidebar-top {
			position: absolute;
			top: 30%;
			left: 0;

			.user {
				width: 36px;
				height: 32px;
				cursor: pointer;
				position: relative;

				.user-item {
					opacity: 0;
					transition: all 0.5s;
					visibility: hidden;
					width: 251px;
					height: 98px;
					background: #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.07);
					position: absolute;
					left: -251px;
					top: -33px;
					padding: 16px 0 16px 16px;
					box-sizing: border-box;

					&::after {
						content: "";
						width: 8px;
						height: 8px;
						background: #ffffff;
						position: absolute;
						right: -4px;
						top: 50%;
						margin-top: -4px;
						transform: rotate(45deg);
						-ms-transform: rotate(45deg);
						-moz-transform: rotate(45deg);
						-webkit-transform: rotate(45deg);
						-o-transform: rotate(45deg);
					}

					.user-item-l {
						.user-item-img {
							width: 66px;
							height: 66px;
							background-color: #cccccc;
							border-radius: 66px;
							overflow: hidden;
						}
					}

					.user-item-r {
						margin-left: 12px;

						.user-name {
							:nth-child(2) {
								height: 12px;
								width: 1px;
								background-color: #d8d8d8;
								margin: 0 14px;
								display: inline-block;
							}

							:nth-child(3) {
								color: #999999;
							}
						}

						.user-item-hui {
							color: #999999;
							margin-top: 12px;
						}
					}
				}
			}

			.coupon {
				width: 36px;
				height: 32px;
				cursor: pointer;
				position: relative;

				.coupon-item {
					opacity: 0;
					transition: all 0.5s;
					visibility: hidden;
					width: 8px;
					height: 8px;
					background: #ffffff;
					position: absolute;
					left: -4px;
					top: 50%;
					margin-top: -4px;
					transform: rotate(45deg);
					-ms-transform: rotate(45deg);
					-moz-transform: rotate(45deg);
					-webkit-transform: rotate(45deg);
					-o-transform: rotate(45deg);
				}
			}

			.cat {
				cursor: pointer;
				width: 36px;
				padding: 10px 0;
				border-top: 1px solid rgba(102, 102, 102, 0.5);
				border-bottom: 1px solid rgba(102, 102, 102, 0.5);
				box-sizing: border-box;
				position: relative;

				.cat-name {
					width: 12px;
					line-height: 18px;
					color: #fff;
					margin: 4px 0;
				}

				.cat-num {
					width: 18px;
					height: 18px;
					background: #ff9010;
					border-radius: 16px;
					color: #fff;
				}

				.cat-item {
					opacity: 0;
					transition: all 0.5s;
					visibility: hidden;
					width: 8px;
					height: 8px;
					background: #ffffff;
					position: absolute;
					left: -4px;
					top: 50%;
					margin-top: -4px;
					transform: rotate(45deg);
					-ms-transform: rotate(45deg);
					-moz-transform: rotate(45deg);
					-webkit-transform: rotate(45deg);
					-o-transform: rotate(45deg);
				}
			}
		}

		.sidebar-bottom {
			position: absolute;
			bottom: 15%;
			left: 0;

			.qr {
				cursor: pointer;
				width: 36px;
				height: 32px;
				position: relative;

				.qr-hidden {
					opacity: 0;
					transition: all 0.5s;
					visibility: hidden;
					width: 280px;
					height: 168px;
					background: #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.07);
					position: absolute;
					left: -280px;
					top: -68px;
					padding: 24px;
					box-sizing: border-box;

					&::after {
						content: "";
						width: 8px;
						height: 8px;
						background: #ffffff;
						position: absolute;
						right: -4px;
						top: 50%;
						margin-top: -4px;
						transform: rotate(45deg);
						-ms-transform: rotate(45deg);
						-moz-transform: rotate(45deg);
						-webkit-transform: rotate(45deg);
						-o-transform: rotate(45deg);
					}

					.qr-item {
						.qr-box {
							width: 102px;
							height: 102px;
							border: 1px solid #ebebeb;
							padding: 5px;
							box-sizing: border-box;

							.qr-img {
								width: 90px;
								height: 90px;
								background: #cccccc;
							}
						}

						.qr-name {
							color: #999999;
						}
					}
				}
			}
		}

		.sidebar-coupon {
			opacity: 0;
			transition: all 0.5s;
			visibility: hidden;
			height: 100%;
			width: 280px;
			background-color: #fff;
			position: absolute;
			left: -280px;
			top: 0;
			padding: 0 16px;
			box-sizing: border-box;
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.07);

			.coupon-tab {
				margin-top: 32px;
				margin-bottom: 20px;

				.coupon-tab-item {
					cursor: pointer;
					color: #666666;
					border-bottom: 2px solid transparent;
					margin-right: 26px;
					padding-bottom: 8px;
					box-sizing: border-box;
				}
			}

			.couponNull {
				width: 100%;
				margin-top: 50px;
			}

			.coupon-item {
				width: 248px;
				height: 96px;
				background: #fff0f1;
				border-radius: 2px;
				border: 1px solid #ff3346;
				padding: 12px;
				box-sizing: border-box;
				margin-bottom: 12px;

				.coupon-top {
					.coupon-pic {
						.num {
							font-size: 24px;
							color: #ff0e25;
							font-weight: bold;
						}

						.meet {
							color: #ff0e25;
							// margin-top: 8px;
						}
					}

					.coupon-btn {
						width: 72px;
						height: 25px;
						background: #ff0e25;
						border-radius: 2px;
						color: #fff;
						cursor: pointer;
					}
				}

				.coupon-time {
					color: #999999;
				}
			}
		}

		.sidebar-cat {
			opacity: 0;
			transition: 0.5s;
			-moz-transition: 0.5s;
			-webkit-transition: 0.5s;
			-o-transition: 0.5s;
			visibility: hidden;
			height: 100%;
			width: 300px;
			background-color: #fff;
			position: absolute;
			left: -300px;
			top: 0;
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.07);

			.cat-bottoms {
				margin-bottom: 0;
			}

			.checkWrap {
				div {
					padding: 0px 3px;
					box-sizing: border-box;
					background: #ccc;
					font-size: 12px;
					color: #fff;
					border-radius: 4px;
					cursor: no-drop;
					margin-right: 2px;
				}
			}

			.zntj {
				width: 100%;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translate(-50%, -50%);
				-moz-transition: translate(-50%, -50%);
				-webkit-transition: translate(-50%, -50%);
				-o-transition: translate(-50%, -50%);

				img {
					display: block;
					width: 93px;
					height: 80px;
					margin: 0 auto 20px;
				}

				p {
					font-size: 14px;
					color: #333;
					text-align: center;
				}
			}

			.noloding {
				width: 100%;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translate(-50%, -50%);
				-moz-transition: translate(-50%, -50%);
				-webkit-transition: translate(-50%, -50%);
				-o-transition: translate(-50%, -50%);

				img {
					display: block;
					width: 198px;
					height: 128px;
					margin: 0 auto 20px;
				}

				p {
					font-size: 14px;
					color: #333;
					text-align: center;

					span {
						padding: 4px 8px;
						box-sizing: border-box;
						font-size: 14px;
						color: #fff;
						border-radius: 2px;
						background: #ff0e25;
						cursor: pointer;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
						}
					}
				}
			}

			.top {
				height: 53px;
				padding: 15px 12px 5px 12px;
				box-sizing: border-box;
				position: absolute;
				top: 0;
				width: 100%;
				background: #fff;
				z-index: 10;

				.top-select {
					color: #666666;

					.top-img {
						height: 12px;
						width: 12px;
						margin-right: 4px;
						cursor: pointer;
					}
				}

				.top-all {
					color: #666666;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
					cursor: pointer;

					&:hover {
						color: #ff0e25;
					}
				}
			}

			.store-box {
				padding-top: 53px;
				padding-bottom: 65px;
				box-sizing: border-box;

				// overflow-y: scroll;
				.shore {
					height: 32px;
					background-color: #f2f2f2;
					padding: 0 12px;
					box-sizing: border-box;

					.shore-select {
						color: #666666;

						.shore-img {
							height: 12px;
							width: 12px;
							margin-right: 4px;
							cursor: pointer;
						}
					}

					.shore-all {
						color: #666666;
					}
				}

				.shop-box {
					padding: 16px 10px;
					box-sizing: border-box;
					// 套餐
					.set-meal{
						.set-meal-title{
							position: relative;
							margin-block: 14px;
							.shop-select {
								height: 12px;
								width: 12px;
								margin-right: 4px;
								cursor: pointer;
							}
							.set-meal-txt{
								color: #F15E34;
								border: 1px solid #F15E34;
								border-radius: 2px;
								background: #FFF0F1;
								width: 28px;
								height: 14px;
								display: flex;
								align-items: center;
								justify-content: center;
								margin-left: 4px;
							}
							.set-meal-name{
								padding: 0 6px;
							}
							.deletecat {
								display: none;
								position: absolute;
								top: -8px;
								right: 0;
								width: 16px;
								height: 16px;
								border-radius: 50%;
								cursor: pointer;
							
								img {
									display: block;
									border-radius: 50%;
									width: 16px;
									height: 16px;
									border-radius: 50%;
								}
							}
						}
						.set-meal-title:hover {
							.deletecat{
								display: block;
							}
						}
						.set-meal-goods{
							.shoped:last-child{
								margin-bottom: 0;
							}
						}
						.set-meal-info{
							padding-right: 12px;
							margin: 10px 0 20px;
							.set-meal-info-cont{
								width: 175px;
							}
						}
					}
					.shoped {
						height: 60px;
						margin-bottom: 20px;
						background: #fff;
						position: relative;

						&:last-child {
							margin-bottom: 5px;
						}

						&:hover .deletecat {
							display: block;
						}

						.deletecat {
							display: none;
							position: absolute;
							top: -8px;
							right: 0;
							width: 16px;
							height: 16px;
							border-radius: 50%;
							cursor: pointer;

							img {
								display: block;
								border-radius: 50%;
								width: 16px;
								height: 16px;
								border-radius: 50%;
							}
						}

						.shop-select {
							height: 12px;
							width: 12px;
							margin-right: 4px;
							cursor: pointer;
						}
						.shop-select.not{
							cursor: auto;
						}
						.shop-img {
							height: 60px;
							width: 60px;
						}

						.shop-r {
							margin-left: 12px;

							.shop-name {
								width: 175px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								line-height: 12px;
								margin-bottom: 6px;

								span {
									margin-right: 5px;
									color: #999;

									&:last-child {
										margin-right: 0;
									}
								}
							}
						}
					}
				}
			}

			.cat-bottom {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 300px;
				padding: 14px 12px 14px 18px;
				box-sizing: border-box;
				border-top: 2px solid #ebebeb;
				background: #fff;
				z-index: 10;

				.bottom-btn {
					width: 116px;
					height: 32px;
					background: #ff0e25;
					border-radius: 2px;
					color: #fff;
					cursor: pointer;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					&:hover {
						box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
					}
				}
			}
		}
	}
</style>
